import React from "react";
import BaseModal from "../../components/BaseModal";
import { MODAL_TYPES } from "../../utils/emitter";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function InsightAnswerPartnerSentModal({ onClose }) {
  const { t } = useTranslation();
  return (
    <BaseModal
      onClose={onClose}
      description={t("insight_questionnaire_form_page.sent")}
      className="insight-answer-modal"
      eventTypeModal={MODAL_TYPES.INSIGHT_ANSWER_PARTNER_SENT}
    />
  );
}
